// Compose a display name from structured parts (#38). Mirrors the DB's
// reconcile trigger: btrim(concat_ws(' ', first, middle, last, suffix)).
export function composeName({ firstName, middleName, lastName, suffix } = {}) {
  return [firstName, middleName, lastName, suffix]
    .map(p => (p || "").trim())
    .filter(Boolean)
    .join(" ");
}

// Suffixes offered in forms — mirrors the parser's recognized set.
export const NAME_SUFFIXES = ["", "Jr", "Sr", "II", "III", "IV", "V"];
